import { FunctionComponent, useMemo } from "react";
import { Place } from "@dto/Place";
import { Tour } from "@dto/Tour";
import { Event } from "@dto/Event";
import { Plannable } from "@dto/Plannable";
import { Goal } from "@dto/Goal";
import { FeedPost } from "@dto/FeedPost";
import { TripBuilderEntity } from "@dto/TripBuilder";
import { Text } from "@ui-kit/Text/Text";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";

import "./Category.css";

interface CategoryProps {
  entity?:
    | Place
    | Tour
    | Event
    | Plannable
    | Goal
    | Tour
    | FeedPost
    | TripBuilderEntity;
}

const Category: FunctionComponent<CategoryProps> = ({ entity }) => {
  const category = useMemo(() => {
    if (!entity?.categoryIds) {
      return;
    }
    return VisitWidget.store.categories.find(
      (x) => x.id === entity?.categoryIds[0],
    );
  }, [entity]);

  if (!category) {
    return <></>;
  }

  return (
    <Text variant="fontBodyMedium" color={colors.neutral600}>
      {category.name}
    </Text>
  );
};

export { Category };
